import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import DentalLabOrderList from "../Assessment/DentalLabOrder/DentalLabOrderList";
import { getDentalLabOrders } from "../../api/dentalLabOrder";
import { notificationAdd } from "../../actions/notification";
import { useAppDispatch } from "../../store/hooks";
import { DentalLabOrder } from "../../interfaces/DentalLabOrder";
import { Client } from "../../interfaces/ClientInterface";
import DentalLabOrderInfo from "../Assessment/DentalLabOrder/DentalLabOrderInfo";

function LabDentalOrderList(): React.JSX.Element {
  const [page, setPage] = React.useState(0);
  const [selectedRow, setSelectedRow] = useState<Partial<DentalLabOrder> | null>(null);
  const [selectedClient, setSelectedClient] = useState<Partial<Client> | null>(null);
  const dispatch = useAppDispatch();
  const [dentalLabOrderData, setDentalLabOrderData] = useState<{
    results: DentalLabOrder[];
    total: number;
  } | null>({
    results: [],
    total: 0
  });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getDentalLabOrders({
          page,
          pageSize: 20,
          clientIds: selectedClient?.id ? [selectedClient.id] : []
        });
        setDentalLabOrderData(data);
      } catch (err) {
        dispatch(
          notificationAdd({
            id: new Date().getUTCMilliseconds(),
            variant: "error",
            message: "Failed to get dental lab orders",
            autoTimeout: true
          })
        );
      }
    })();
  }, [page, dispatch, selectedClient?.id]);

  return (
    <Box height="100%" pt={2}>
      <DentalLabOrderList
        doNotHandleRowClick
        hideCreateButton
        page={page}
        setPage={setPage}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        dentalLabOrderData={dentalLabOrderData}
      />
      {selectedRow && (
        <DentalLabOrderInfo
          setDentalLabOrderData={setDentalLabOrderData}
          selectedRow={selectedRow}
          onClose={() => {
            setSelectedRow(null);
          }}
        />
      )}
    </Box>
  );
}

export default LabDentalOrderList;
